import { render, staticRenderFns } from "./Superadmin.vue?vue&type=template&id=5316073d&scoped=true&"
import script from "./Superadmin.vue?vue&type=script&lang=js&"
export * from "./Superadmin.vue?vue&type=script&lang=js&"
import style0 from "./Superadmin.vue?vue&type=style&index=0&id=5316073d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5316073d",
  null
  
)

export default component.exports